export const FETCH_SEATSMAP_START = 'FETCH_SEATSMAP_START';
export const FETCH_SEATSMAP_SUCCESS = 'FETCH_SEATSMAP_SUCCESS';
export const FETCH_SEATSMAP_FAILURE = 'FETCH_SEATSMAP_FAILURE';

export const SET_SEATSMAP_MATRIX = 'SET_SEATSMAP_MATRIX';

export const RESET_SEATS = 'RESET_SEATMAP';